import { isLightColor } from "../lib/tileColor";

const shade = (hex, amt) => {
  const n = parseInt(hex.slice(1), 16);
  const f = (v) => Math.max(0, Math.min(255, Math.round(v * (1 - amt))));
  return `#${[f((n >> 16) & 255), f((n >> 8) & 255), f(n & 255)].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
};

export const HolidayTint = ({ tint }) => {
  const main = isLightColor(tint.c1) ? shade(tint.c1, 0.45) : tint.c1;
  const hover = shade(main, 0.15);
  const css = `
header{border-bottom:0!important}
header::after{content:"";position:absolute;left:0;right:0;bottom:-4px;height:4px;background:repeating-linear-gradient(90deg,${tint.c1} 0 28px,${tint.c2} 28px 56px)}
.bg-\\[\\#F5551E\\]{background-color:${main}!important}
.hover\\:bg-\\[\\#E04812\\]:hover,.hover\\:bg-\\[\\#e04812\\]:hover{background-color:${hover}!important}
.text-\\[\\#F5551E\\]{color:${main}!important}
.border-\\[\\#F5551E\\]{border-color:${main}!important}`;
  return <style data-testid="holiday-tint">{css}</style>;
};
